import { action } from 'satcheljs';

export default action(
    'navigateToOptionLink',
    (category?: string, subcategory?: string, option?: string) => ({
        category,
        subcategory,
        option,
    })
);
